<script>
import { Doughnut, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Doughnut,
  mixins: [reactiveProp],
  data () {
    return {
      options: {
        legend: {
          display: false
        },
        tooltips: {
          callbacks: {
            label: function (tooltip, datasets) {
              var tool = ''
              if (tooltip.index === 1) {
                tool = datasets.labels[1] + ': ' + Math.round(datasets.datasets[0].data[1])
              } else {
                tool = datasets.labels[0] + ': ' + Math.round(datasets.datasets[0].data[0])
              }
              return tool
            }
          }
        },
        responsive: true,
        maintainAspectRatio: false
      }
    }
  },
  mounted () {
    // this.chartData is created in the mixin.
    // If you want to pass options please create a local options object
    this.renderChart(this.chartData, this.options)
  }
}
</script>
